export const DEFAULT_CONFERENCE_TYPE_OPTIONS = [
  { value: "mm", name: "M&M Conference", abbreviation: "M&M", color: "#0d6efd" },
  { value: "ground_rounds", name: "GR Conference", abbreviation: "GR", color: "#198754" },
  { value: "both", name: "M&M & GR Conference", abbreviation: "M&G", color: "#fd7e14" },
  { value: "educational", name: "Education Conference", abbreviation: "EDU", color: "#0dcaf0" },
  { value: "journal_club", name: "Journal Club", abbreviation: "JC", color: "#6c757d" },
];

export const normalizeConferenceTypeValue = (input) =>
  (input || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const resolveConferenceTypeDisplay = (type, options = DEFAULT_CONFERENCE_TYPE_OPTIONS) => {
  const found = (options || []).find((opt) => opt.value === type);
  if (found) {
    return {
      label: found.abbreviation || found.name || type,
      color: normalizeHexColor(found.color),
      name: found.name || type,
    };
  }
  return { label: type, color: "#6c757d", name: type };
};

export const normalizeHexColor = (input, fallback = "#6c757d") => {
  const value = (input || "").toString().trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(value)) return value;
  if (/^#[0-9A-Fa-f]{3}$/.test(value)) {
    const r = value[1];
    const g = value[2];
    const b = value[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }

  const bootstrapToHex = {
    primary: "#0d6efd",
    secondary: "#6c757d",
    success: "#198754",
    danger: "#dc3545",
    warning: "#fd7e14",
    info: "#0dcaf0",
    dark: "#212529",
  };

  return bootstrapToHex[value.toLowerCase()] || fallback;
};

export const toTransparentBadgeStyle = (hexColor) => ({
  background: `${hexColor}20`,
  color: hexColor,
  border: `1px solid ${hexColor}55`,
});
